import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classnames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import { Button, ButtonGroup, ControlLabel, FormGroup, Row } from '@cancercentrum/rcc-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';
import { IncaRowContext } from '../IncaRowContext';
import { Explanation } from '../Explanation';
import { useDataActions } from '../../hooks/useDataActions';
import { useClearable } from '../../hooks/useClearable';
const defaultFormatter = (item)=>item.text;
const defaultIsOptionDisabled = ()=>false;
export function MultiSelectList(props) {
    const { formatter = defaultFormatter, tabIndex = 0, vertical = false, RowContext = IncaRowContext, isOptionDisabled = defaultIsOptionDisabled, selectedBsStyle = 'info', subTable, shortname, availableListValues, titleFormatter, onToggle, labelHelp, labelHelpTitle, labelClassName, wrapperClassName, appendAfter, help, renderRow } = props;
    const id = useMemo(()=>{
        return props.id || uniqueId('MSL_');
    }, [
        props.id
    ]);
    const dataActions = useDataActions();
    useClearable((row)=>row.clearSubTable(props.subTable.$rcc.tableName));
    const getListValues = ()=>{
        const regvarMetadata = subTable.$rcc.tableMetadata.regvars[shortname];
        const allListValues = (props.options || regvarMetadata.listValues).filter((x)=>x.text);
        if (!availableListValues) {
            return allListValues;
        }
        return availableListValues.reduce((r, v)=>{
            const match = allListValues.find((x)=>x.value === v);
            if (!match) {
                // eslint-disable-next-line no-console
                console.warn('No list item with value "${v}" was found.');
                return r;
            }
            r.push(match);
            return r;
        }, []);
    };
    const onToggleValue = (item)=>{
        const row = subTable.getRows().find((x)=>x.getRegvar(shortname).value === item.id);
        if (row) {
            dataActions.updateRow((x)=>x.removeSubTableRow(row));
        } else {
            const newRow = subTable.createRow().setRegvarValue(shortname, item.id);
            dataActions.updateRow((x)=>x.addSubTableRow(newRow));
        }
        if (onToggle) {
            onToggle(item, !row);
        }
    };
    const regvarMetadata = subTable.$rcc.tableMetadata.regvars[shortname];
    const label = props.label || regvarMetadata.label || '[etikett saknas]';
    const options = getListValues();
    const rows = subTable.getRows();
    const selectedIds = rows.map((x)=>x.getRegvar(shortname).value).toArray();
    const buttons = options.reduce((reduction, x)=>{
        const isSelected = selectedIds.includes(x.id);
        const title = titleFormatter ? titleFormatter(x) : '';
        reduction.push(/*#__PURE__*/ _jsxs(Button, {
            className: classnames({
                active: isSelected
            }),
            title: title,
            tabIndex: tabIndex,
            onClick: ()=>onToggleValue(x),
            disabled: isOptionDisabled(x),
            style: {
                textAlign: 'left'
            },
            bsStyle: isSelected ? selectedBsStyle : undefined,
            children: [
                /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                    icon: isSelected ? faCheckSquare : faSquare,
                    style: {
                        marginRight: '.5rem'
                    }
                }),
                formatter(x)
            ]
        }, x.id));
        return reduction;
    }, []);
    const helpNode = labelHelp ? /*#__PURE__*/ _jsx(Explanation, {
        title: labelHelpTitle,
        children: labelHelp
    }) : undefined;
    return /*#__PURE__*/ _jsxs("div", {
        className: "multi-select-list",
        children: [
            /*#__PURE__*/ _jsxs(FormGroup, {
                componentClass: Row,
                controlId: id,
                children: [
                    /*#__PURE__*/ _jsxs(ControlLabel, {
                        column: true,
                        className: labelClassName,
                        children: [
                            label,
                            " ",
                            helpNode
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: wrapperClassName,
                        children: [
                            /*#__PURE__*/ _jsx(ButtonGroup, {
                                vertical: vertical,
                                children: buttons
                            }),
                            " ",
                            appendAfter,
                            !!help && /*#__PURE__*/ _jsx("div", {
                                className: "form-text",
                                children: help
                            })
                        ]
                    })
                ]
            }),
            renderRow && rows.sortBy((x)=>options.indexOf(x.getRegvarValue(shortname))).map((x)=>/*#__PURE__*/ _jsx(RowContext, {
                    tableName: x.$rcc.tableName,
                    rowId: x.getId(),
                    children: ({ dataActions: rowDataActions })=>renderRow({
                            row: x,
                            dataActions: rowDataActions
                        })
                }, x.getId()))
        ]
    });
}
